import { useRenew } from "./flow/context";
import { RenewConfirmation } from "./RenewConfirmation";

export function RenewConfirmationScreen() {
  const { transitionDate, isRecent, onLogout } = useRenew();

  if (!transitionDate) {
    return null;
  }

  return (
    <RenewConfirmation
      transitionDate={transitionDate}
      isRecent={isRecent}
      onDone={() => {
        onLogout("renewal_success");
      }}
    />
  );
}
